import { Link, useNavigate } from "react-router-dom";
import React, { EventHandler, MouseEventHandler, useEffect, useRef, useState } from "react";
import '../styles/Layout.css';
import { Outlet } from "react-router-dom";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Button,
  Avatar,
  Badge,
  IconButton,
  Typography,
  Navbar,
  MobileNav,
  Collapse,
  Drawer,
  button,
  Checkbox,
  Select,
  Option,
} from "@material-tailwind/react";

import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon, MagnifyingGlassIcon, ShoppingBagIcon, UserIcon } from "@heroicons/react/24/solid";
import LoadingSpinner from "./LoadingSpinner";
import { Footer } from "./Footer";
import parseJwt from "../services/parseJwt";
import { QuantityButton } from "./QuantityButton";
import { formatPrice } from "../services/formatPrice";
import { CartProductRow } from "./CartProductRow";
import SuccessNotification from "./SuccessNotification";
import { useCartFunctions } from "../services/ApiServices/CartProductService";

type LayoutProps = {
  products: any,
  setProducts: (products: any) => void,
  token: string | null,
  role: string,
  removeToken: () => void,
  setToken: (userToken: string) => void,
  successMessage: string,
  selectedProducts: any[],
  setSelectedProducts: (products: any) => void,
  totalPrice: number,
  setTotalPrice: (totalPrice: number) => void,
  GetAllProductsByUserId: (userId: string) => Promise<any>,
  DeleteCartProduct: (id: string) => Promise<void>
  UpdateProductQuantity: (updateQuantity: any) => Promise<void>
  loading: boolean,
  setSuccessMessage: (message: string) => void,
};

function Layout({ products, UpdateProductQuantity, GetAllProductsByUserId, DeleteCartProduct, totalPrice, setTotalPrice, selectedProducts, setSelectedProducts, setProducts, token, role, removeToken, setToken, loading, successMessage, setSuccessMessage }: LayoutProps) {
  const [openMenu, setOpenMenu] = React.useState(false);
  const [openNav, setOpenNav] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSearch = () => {
    if (searchKeyword.trim() !== "") {
      navigate(`/products?query=${encodeURIComponent(searchKeyword)}`);
    }
  };

  const [scrollDown, setScrollDown] = React.useState(false);


  const [errorMessage, setErrorMessage] = React.useState("");
  const id = token ? parseJwt(token).id : null
  const navigate = useNavigate();

  const fetchProductsInCart = async () => {
    let products = null;
    try {
      products = await GetAllProductsByUserId(id);
      setProducts(products);
    }
    catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const navigateToPayment = async () => {
    let products: any = null;
    if (!id) {
      navigate("login");
      return;
    }
    try {
      products = await GetAllProductsByUserId(id);
      setProducts(products);
      console.log(products)
      const selectProds = products.filter((product: any) => selectedProducts.find((selectedProduct: any) => selectedProduct.id === product.id));
      console.log(selectProds)
      setSelectedProducts(selectProds);
      navigate("payment",
        {
          state: {
            selectedProductsPrice: totalPrice,
            products: selectProds
          }
        });
    }
    catch (error: any) {
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again later.');
      }
      return;
    }
  }

  const openCart = async () => {
    await fetchProductsInCart();
    openDrawer();
  };

  const goToLink = (link: string) => {
    navigate(link);
  };

  const logOut = () => {
    removeToken();
    navigate("/");
  };

  const [open, setOpen] = React.useState(false);

  const openDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  useEffect(() => {
    fetchProductsInCart();
  }
    , [token])

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        window.innerWidth >= 960 && setOpenNav(false);
      }
    );

    const userAgent = navigator.userAgent;
    if (userAgent.match(/Android/i) || userAgent.match(/webOS/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPad/i) || userAgent.match(/iPod/i) || userAgent.match(/BlackBerry/i) || userAgent.match(/Windows Phone/i)) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
      window.addEventListener('scroll', function () {
        if (window.innerWidth >= 960) {
          if (window.scrollY > 100) {
            setScrollDown(true)
          } else {
            setScrollDown(false)
          }

        }
      });
    }
  }, []);

  const navList = (
    <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className={`flex items-center gap-x-2 p-1 font-medium ${scrollDown ? "" : "hidden"}`}
        placeholder={""}
      >
        <Link to="/" className="flex items-center">
          <img className="w-10" src="/Official-Hor.png" />
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/" className="flex items-center">
          <span>Trang chủ</span>
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/about" className="flex items-center">
          <span>Về chúng tôi</span>
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/products" className="flex items-center">
          <span>Sản phẩm</span>

        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="https://www.facebook.com/profile.php?id=61566471451232" className="flex items-center">
          <span>Liên hệ</span>
        </Link>
      </Typography>
    </ul>
  )

  const adminNavList = (
    <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/" className="flex items-center">
          <span>Trang chủ</span>
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/about" className="flex items-center">
          <span>Về chúng tôi</span>
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="flex items-center gap-x-2 p-1 font-medium"
        placeholder={""}
      >
        <Link to="/dashboard/products" className="flex items-center">
          <span>Sản phẩm</span>
        </Link>
      </Typography>
    </ul>
  )


  return (
    <>
      <Drawer open={open} size={500} overlayProps={{ className: "fixed" }} placement="right" onClose={closeDrawer} className="p-4" placeholder={""}>
        <div className={isMobile ? "scroll-cart-mobile" : "scroll-cart"} style={{ height: window.screen.height - 250 + "px" }}>
          <div className="mb-2 flex items-center justify-between">
            <Typography className="flex-grow text-center" variant="h5" color="blue-gray" placeholder={""}>
              Giỏ hàng ({products.length} items)
            </Typography>
            <IconButton variant="text" color="blue-gray" onClick={closeDrawer} placeholder={""}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="h-5 w-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </IconButton>
          </div>
          <hr className="w-full bg-gray-800 mb-4" />
          <div className="">
            {products.length > 0 && products.map((product: any) => (
              <CartProductRow UpdateProductQuantity={UpdateProductQuantity} DeleteCartProduct={DeleteCartProduct} selectedProducts={selectedProducts} setSelectedProducts={setSelectedProducts} products={products}
                setProducts={setProducts} fetchCartProduct={fetchProductsInCart}
                product={product} key={product.id} totalPrice={totalPrice} setTotalPrice={setTotalPrice} />
            ))}
          </div>

        </div>
        <div className={"purchase-btn"}>
          <Typography variant="h5" color="gray" placeholder={""}>Tổng thanh toán:
            <span className="text-red-500">{formatPrice(totalPrice)}</span>
          </Typography>
          <Button variant="filled" fullWidth={true} color="orange" placeholder={""}
            onClick={async () => {
              await navigateToPayment();
              setOpen(false);
            }}>Thanh toán
          </Button>
        </div>
      </Drawer>
      <>
        {loading && <LoadingSpinner />}
        {successMessage && <SuccessNotification message={successMessage} setMessage={setSuccessMessage} />}
        <div className="loco-first-nav hidden lg:flex flex-wrap justify-between">
          <div className="navbar-first flex items-center" style={{ height: "50px" }}>Hỗ trợ 24/7: (+84)90 2984 218</div>
          <img className="navbar-logo" src="/Official-Hor.png" alt="" />
          {!token ?
            <div className="navbar-end flex flex-wrap justify-evenly">
              <Button variant="text" placeholder={""} onClick={() => goToLink("login")} className="loco-btn">Đăng nhập</Button>
              <div style={{ margin: "auto 0" }}>|</div>
              <Button variant="text" placeholder={""} onClick={() => goToLink("login")} className="loco-btn">Đăng ký</Button>
            </div> :
            <div className="navbar-end flex flex-wrap items-center justify-end">
            </div>
          }
        </div>
        <Navbar id="navbar" className="sticky top-0 z-50 mx-auto px-4 py-2 lg:px-8 lg:py-1" fullWidth={true} placeholder={""}>
          <div className="flex justify-between">
            <div className="flex items-center text-blue-gray-900">
              <Typography
                as="a"
                href="#"
                className="block lg:hidden mr-4 cursor-pointer py-1.5 font-medium"
                placeholder={""}
              >

                <img className="" style={{ width: "50px" }} src="/Official-Hor.png" alt="" />
              </Typography>
              <div className="hidden lg:block">{role == "Admin" ? adminNavList : navList}</div>
              <IconButton
                variant="text"
                className="h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
                ripple={false}
                onClick={() => setOpenNav(!openNav)}
                placeholder={""}
              >
                {openNav ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    className="h-6 w-6"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </IconButton>
            </div>

            <div className="flex items-center gap-x-1">
              <input
                className="text-black ml-3"
                type="text"
                placeholder="Nhập từ khóa tìm kiếm..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
              />
              <Button variant="text" placeholder={""} onClick={handleSearch} className="loco-btn">
                <MagnifyingGlassIcon className="h-4 w-4 transition-transform" />
              </Button>
              <Button variant="text" placeholder={""} onClick={openCart} className="loco-btn">
                {products.length > 0 ? <Badge content={`${products.length}`}>
                  <ShoppingBagIcon className="h-4 w-4 transition-transform" />
                </Badge> :
                  <ShoppingBagIcon className="h-4 w-4 transition-transform" />
                }
              </Button>
              {token && <Menu>
                <MenuHandler>
                  <Button variant="text" placeholder={""} onClick={() => goToLink("profile")} className="loco-btn">
                    <img src="/User_alt.svg" alt="" style={{ cursor: "pointer" }} />
                  </Button>
                </MenuHandler>
                <MenuList placeholder={""}>
                  <MenuItem className="loco-btn" onClick={() => goToLink("profile")}
                    placeholder={""}>
                    Hồ sơ
                  </MenuItem>
                  <MenuItem className="loco-btn" onClick={() => goToLink("order")}
                    placeholder={""}>
                    Đơn hàng
                  </MenuItem>
                  {role == "Admin" && <MenuItem className="loco-btn" onClick={() => goToLink("dashboard")}
                    placeholder={""}>
                    Dashboard
                  </MenuItem>}
                  <MenuItem className="loco-btn" onClick={() => logOut()}
                    placeholder={""}>
                    Đăng xuất
                  </MenuItem>
                </MenuList>
              </Menu>}
            </div>
          </div>
          <Collapse open={openNav}>
            <div className="container mx-auto" onClick={() => setOpenNav(false)}>
              {navList}
              {!token ? <div className="flex items-center gap-x-1">
                <Button onClick={() => goToLink("/login")} fullWidth variant="text" size="sm" className="" placeholder={""}>
                  <span>Đăng nhập</span>
                </Button>
                <Button onClick={() => goToLink("/login")} fullWidth variant="gradient" size="sm" className="" placeholder={""}>
                  <span>Đăng ký</span>
                </Button>
              </div> : <>
                <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
                  {(role == "Admin" && <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="flex items-center gap-x-2 p-1 font-medium"
                    placeholder={""}
                  >
                    <Link to="/profile" className="flex items-center">
                      <span>Hồ sơ</span>
                    </Link>
                  </Typography>)}
                  {(role == "Admin" && <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="flex items-center gap-x-2 p-1 font-medium"
                    placeholder={""}
                  >
                    <Link to="/dashboard" className="flex items-center">
                      <span>Dashboard</span>
                    </Link>
                  </Typography>)}
                </ul>
                <div className="flex items-center gap-x-1">
                  <Button onClick={() => logOut()} fullWidth variant="gradient" size="sm" className="" placeholder={""}>
                    <span>Đăng xuất</span>
                  </Button>
                </div></>
              }
            </div>
          </Collapse>
        </Navbar>                {/*</div>*/}

        {/*</nav>*/}
      </>
      <main className="w-full flex flex-wrap items-center">
        <Outlet />
      </main>
      <Footer />
    </>
  )
}

export default Layout;
